const baseUrl = "https://purecatamphetamine.github.io/country-flag-icons/3x2/";

export default {
  Algeria: baseUrl + "DZ.svg",
  Argentina: baseUrl + "AR.svg",
  ARG: baseUrl + "AR.svg",
  Australia: baseUrl + "AU.svg",
  Austria: baseUrl + "AT.svg",
  AUT: baseUrl + "AT.svg",
  Belgium: baseUrl + "BE.svg",
  "Bosnia & Herzogovina": baseUrl + "BA.svg",
  Brazil: baseUrl + "BR.svg",
  BRA: baseUrl + "BR.svg",
  Cameroon: baseUrl + "CM.svg",
  Canada: baseUrl + "CA.svg",
  "Cape Verde": baseUrl + "CV.svg",
  Colombia: baseUrl + "CO.svg",
  "Costa Rica": baseUrl + "CR.svg",
  Croatia: baseUrl + "HR.svg",
  Curacao: baseUrl + "CW.svg",
  Czechia: baseUrl + "CZ.svg",
  Denmark: baseUrl + "DK.svg",
  "DR Congo": baseUrl + "CD.svg",
  Ecuador: baseUrl + "EC.svg",
  Egypt: baseUrl + "EG.svg",
  EGY: baseUrl + "EG.svg",
  England: baseUrl + "GB-ENG.svg",
  ENG: baseUrl + "GB-ENG.svg",
  France: baseUrl + "FR.svg",
  FRA: baseUrl + "FR.svg",
  Germany: baseUrl + "DE.svg",
  GER: baseUrl + "DE.svg",
  Ghana: baseUrl + "GH.svg",
  Haiti: baseUrl + "HT.svg",
  Italy: baseUrl + "IT.svg",
  ITA: baseUrl + "IT.svg",
  Iran: baseUrl + "IR.svg",
  Iraq: baseUrl + "IQ.svg",
  "Ivory Coast": baseUrl + "CI.svg",
  Japan: baseUrl + "JP.svg",
  JAP: baseUrl + "JP.svg",
  Jordan: baseUrl + "JO.svg",
  Mexico: baseUrl + "MX.svg",
  MEX: baseUrl + "MX.svg",
  Morocco: baseUrl + "MA.svg",
  MOR: baseUrl + "MA.svg",
  Netherlands: baseUrl + "NL.svg",
  Norway: baseUrl + "NO.svg",
  "New Zealand": baseUrl + "NZ.svg",
  NZL: baseUrl + "NZ.svg",
  Panama: baseUrl + "PA.svg",
  Paraguay: baseUrl + "PY.svg",
  Poland: baseUrl + "PL.svg",
  Portugal: baseUrl + "PT.svg",
  POR: baseUrl + "PT.svg",
  Qatar: baseUrl + "QA.svg",
  "Saudi Arabia": baseUrl + "SA.svg",
  SAU: baseUrl + "SA.svg",
  Senegal: baseUrl + "SN.svg",
  Serbia: baseUrl + "RS.svg",
  "South Africa": baseUrl + "ZA.svg",
  RSA: baseUrl + "ZA.svg",
  "South Korea": baseUrl + "KR.svg",
  KOR: baseUrl + "KR.svg",
  Spain: baseUrl + "ES.svg",
  ESP: baseUrl + "ES.svg",
  Scotland: baseUrl + "GB-SCT.svg",
  Sweden: baseUrl + "SE.svg",
  Switzerland: baseUrl + "CH.svg",
  Tunisia: baseUrl + "TN.svg",
  TUN: baseUrl + "TN.svg",
  Turkiye: baseUrl + "TR.svg",
  "United Arab Emirates": baseUrl + "AE.svg",
  UAE: baseUrl + "AE.svg",
  "United States": baseUrl + "US.svg",
  USA: baseUrl + "US.svg",
  Uruguay: baseUrl + "UY.svg",
  Uzbekistan: baseUrl + "UZ.svg",
  Wales: baseUrl + "GB-WLS.svg",
};
